import { Widget } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { CompanyDeal } from '../../../../models/CompanyDeal';
import styles from './CompanyDealsWidget.module.scss';
import CompanyDealsWidgetContent from './CompanyDealsWidgetContent';

const cx = classNames.bind(styles);

interface CompanyDealsPrintWidgetProps {
  secondLine: ReactElement;
  deals: CompanyDeal[];
}

const CompanyDealsPrintWidget = ({ secondLine, deals }: CompanyDealsPrintWidgetProps): ReactElement => {
  return (
    <div className={cx('body')}>
      <Widget headerTitle="Deals" secondLine={secondLine}>
        <CompanyDealsWidgetContent deals={deals} />
      </Widget>
    </div>
  );
};

export default CompanyDealsPrintWidget;
